import React from 'react';
import { createPortal } from 'react-dom';

export const PortalInOverlay: React.FC<React.PropsWithChildren> = ({
  children,
}) =>
  createPortal(
    children,
    document.getElementById('bbk-app-root') || document.body
  );
